import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { SchedulePreview } from '../../types';

interface ScheduleCardProps {
  data: SchedulePreview;
}

export function ScheduleCard({ data }: ScheduleCardProps) {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader className="p-4 pb-2">
        <CardTitle className="text-sm">Schedule</CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-0">
        <div className="relative space-y-4 pl-4 border-l-2 border-muted">
          {data.items.map((item) => (
            <div
              key={item.id}
              className="relative cursor-pointer hover:bg-muted/50 rounded p-2 -ml-4 pl-4 transition-colors"
              onClick={() => navigate(item.detailUrl)}
            >
              <div className="absolute -left-[9px] top-3 h-3 w-3 rounded-full border-2 border-primary bg-background" />
              <p className="text-xs text-muted-foreground">
                {new Date(item.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                {' to '}
                {new Date(item.endTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </p>
              <div className="flex items-center gap-2 mt-0.5">
                <span className="text-sm font-medium">{item.title}</span>
                <Badge variant="secondary">{item.type}</Badge>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
